// @ts-check

/**
 * Product form Web Component.
 * - Quantity increment/decrement
 * - Add to cart with loading state
 * - Cart:change event dispatch
 */
(() => {
  class ProductForm extends HTMLElement {
    connectedCallback() {
      /** @type {HTMLFormElement | null} */
      this.form = this.querySelector('form');
      /** @type {HTMLInputElement | null} */
      this.quantityInput = this.querySelector('.quantity-input');
      /** @type {HTMLButtonElement | null} */
      this.submitButton = this.querySelector('.product-form__submit');

      if (!this.form || !this.quantityInput || !this.submitButton) return;

      // Quantity buttons
      this.querySelectorAll('.quantity-button').forEach((button) => {
        button.addEventListener('click', () => {
          const action = button.getAttribute('data-action');
          const current = parseInt(this.quantityInput?.value || '1', 10);

          if (action === 'increment') {
            if (this.quantityInput) this.quantityInput.value = String(current + 1);
          } else if (action === 'decrement' && current > 1) {
            if (this.quantityInput) this.quantityInput.value = String(current - 1);
          }
        });
      });

      // Form submit
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this._handleSubmit();
      });
    }

    async _handleSubmit() {
      if (!this.form || !this.submitButton) return;

      const formData = new FormData(this.form);
      const submitText = this.submitButton.querySelector('.product-form__submit-text');

      // Loading state
      this.submitButton.disabled = true;
      if (submitText) submitText.textContent = 'Adding...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        });

        if (!response.ok) throw new Error('Failed to add to cart');

        // Fetch full cart state for accurate count
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        // Success state
        if (submitText) submitText.textContent = 'Added!';

        // Dispatch cart:change (triggers drawer auto-open + header count)
        document.dispatchEvent(
          new CustomEvent('cart:change', {
            detail: { count: cart.item_count },
          })
        );

        // Reset after 2 seconds
        setTimeout(() => {
          if (this.submitButton) this.submitButton.disabled = false;
          if (submitText) submitText.textContent = 'Add to Bag';
        }, 2000);
      } catch (error) {
        console.error('Add to cart error:', error);

        // Error state
        if (submitText) submitText.textContent = 'Error - Try Again';
        setTimeout(() => {
          if (this.submitButton) this.submitButton.disabled = false;
          if (submitText) submitText.textContent = 'Add to Bag';
        }, 2000);
      }
    }
  }

  customElements.define('product-form', ProductForm);
})();
